import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=a5f3336c&scoped=true"
import script from "./DocumentTable.vue?vue&type=script&lang=ts"
export * from "./DocumentTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=a5f3336c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f3336c",
  null
  
)

export default component.exports